import React from "react";
import TableCell, { ExcelTableCellProps } from "./TableCell";
import { observer } from "mobx-react";
import _ from "lodash";
import { CellProps } from "../../stores/card/ModeExcel";

@observer
export default class ExcelTableMutilContent extends React.Component<ExcelTableCellProps, any> {
    render() {
        const { cell, excel,form ,contentType,detail,content,card,index,className} = this.props;
        const mc = cell.mcpoint && excel.getMutilContent(cell.mcpoint);
        const contents: JSX.Element[][] = [];
        let colIndex = 0;
        let rowIndex = 0;
        const verifyColor: any = {};
        mc && mc.cells && mc.cells.map((mcCell: CellProps) => {
            if (mcCell.etype == '14') {
                if (mcCell.brsign == 'Y') {
                    rowIndex += 1;
                    colIndex = 0;
                }
                return;
            }
            if (mcCell && mcCell.etype == '3' && form.has(mcCell.getPath())) {
                const color = form.$(mcCell.getPath()).color;
                if (color) {
                    _.set(verifyColor, "background", color);
                }
            }
            let prop={};
            if(mcCell&&mcCell.otherProps&&mcCell.otherProps.id){
                prop={id:mcCell.otherProps.id};
            }
            _.set(contents, `[${rowIndex}].[${colIndex}]`, (
                <div style={mcCell.style} {...prop}>
                    <TableCell 
                        excel={excel}
                        contentType={contentType}
                        form={form}
                        card={card}
                        index={index}
                        detail={detail}
                        content={content}
                        className={className}
                        cell={mcCell} 
                    />
                </div>
            ));
            colIndex++;
        });
        return (
            <div className="cube-mutil-content" style={{...verifyColor}}>
                {contents.map((row = []) => (
                    <div>
                        {row && row.map(col => (
                            <div style={{ display: 'inline-block',verticalAlign:"middle" }}>
                                {col}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/MutilContent.tsx